import Vue from 'vue';
import VueTypeScriptInject from 'vue-typescript-inject';
import VueRx from 'vue-rx';
import Header from '@/components/layout/header.vue';
import App from '@/App.vue';
import Footer from '@/components/layout/footer.vue';
import router from '@/router';
import store from '@/store';

Vue.config.productionTip = false;
Vue.use(VueTypeScriptInject);
Vue.use(VueRx);

// vue-mq
((): void => {
  Vue.use(require('vue-mq').default, {breakpoints: store.getters.breakpoints});
  Vue.mixin({
    methods: {
      mq(value: string): boolean {
        const breakpoints: any = this.$store.getters.breakpoints;
        const list: string[] = Object.keys(breakpoints);
        const mq: number = list.indexOf((this as any).$mq);

        if (value.indexOf('+') !== -1) {
          return mq >= list.indexOf(value.slice(0, -1));
        } else if (value.indexOf('-') !== -1) {
          return mq <= list.indexOf(value.slice(0, -1));
        } else {
          return mq === list.indexOf(value);
        }
      },
    },
  });
})();

// forEach polyfill
if (! NodeList.prototype.forEach) {
  NodeList.prototype.forEach = (Array.prototype as any).forEach;
}

// object-fit polyfill
((): void => {
  const objectFitImages: any = require('object-fit-images');
  objectFitImages();
})();

// vueinview
((): void => {
  Vue.use(require('vueinview'));
})();

new Vue({
  router,
  store,
  render: (h) => h(Header),
}).$mount('#header');

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');

new Vue({
  router,
  store,
  render: (h) => h(Footer),
}).$mount('#footer');
